module.exports = __webpack_public_path__ + "static/sekine_kenta-fad9a9e00e31fe52b2e5e82836ba57b6.jpg";